  import React, { useState } from "react";
  import { Box, TextField, Button, Typography } from "@mui/material";

  const RiteDepartmentForm = ({
    title,
    defaultValues = {},
    onSubmit
  }) => {

    const [form,setForm] = useState({
      title: defaultValues.title || "",
      description: defaultValues.description || "",
      contact_email: defaultValues.contact_email || "",
      phone: defaultValues.phone || ""
    });

    const handleChange = (e) => {
      setForm({...form,[e.target.name]:e.target.value});
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      onSubmit(form);
    };

    return (
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{maxWidth:500}}
      >

        <Typography variant="h6" mb={2}>
          {title}
        </Typography>

        <TextField
          label="Title"
          name="title"
          fullWidth
          required
          value={form.title}
          onChange={handleChange}
          sx={{mb:2}}
        />

        <TextField
          label="Description"
          name="description"
          fullWidth
          multiline
          rows={3}
          value={form.description}
          onChange={handleChange}
          sx={{mb:2}}
        />

        <TextField
          label="Contact Email"
          name="contact_email"
          fullWidth
          value={form.contact_email}
          onChange={handleChange}
          sx={{mb:2}}
        />

        <TextField
          label="Phone"
          name="phone"
          fullWidth
          value={form.phone}
          onChange={handleChange}
          sx={{mb:2}}
        />

        <Button type="submit" variant="contained">
          Save
        </Button>

      </Box>
    );
  };

  export default RiteDepartmentForm;